import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';
import { Division, DivisionSalesNetwork } from '../../../../models/division.model';
import { SelfScanConf, SelfScanConfDetail } from '../../../../models/loyalty-selfScan.model';
import { CalendarTranslateService } from '../../../../modules/UIKit/services/calendarTranslate.service';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { DivisionSalesNetworkService } from '../../../../services/division-sales-network/divison-sales-network.service';
import { LoyaltySelfscanconfService } from '../../../../services/loyalty/loyalty-selfscanconf.service';
import { LoyaltySelfscanconfdetailService } from '../../../../services/loyalty/loyalty-selfscanconfdetail.service';
import { LoyaltyParamsService } from './../../../../services/loyalty/params.service';


@Component({
  selector: 'app-form-self-scan-rules',
  templateUrl: './form-self-scan-rules.component.html',
  styleUrls: ['./form-self-scan-rules.component.css']
})
export class FormSelfScanRulesComponent implements OnInit {

  fields: any;

  form: FormGroup;
  @Input() selfscanId: number;
  @Input() editMode: boolean;
  divisionSales: Array<{value: number, label: string}>;
  selfdetailsForm: Array<FormGroup>;

  validationSelfScan: any;
  validationSelfScanDetails: any;
  paramSelfScan = {
    chk_min_num: 0,
    chk_max_num: 0,
    tx_interval: 0,
    void_qta_max: 0,
    void_val_max: 0,
    num_valid_check: 0,
    min: 0,
    max: 0,
    step: 0,
    min_tx_check: 10000,
    max_tx_check: 10000,
    default_check_chance: 10000
  }

  validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative,
    decimalNotNegative: KoncentroValidators.decimalNotNegative,
    checkDateMajorOther_dateStart: KoncentroValidators.checkDateMajorOther('date_end'),
    checkDateMinorOther_dateEnd: KoncentroValidators.checkDateMinorOther('date_start'),
    chk_min_num: ((control: AbstractControl) => Validators.max(this.paramSelfScan.chk_min_num)(control)),
    chk_max_num: ((control: AbstractControl) => Validators.max(this.paramSelfScan.chk_max_num)(control)),
    tx_interval: ((control: AbstractControl) => Validators.max(this.paramSelfScan.tx_interval)(control)),
    void_qta_max: ((control: AbstractControl) => Validators.max(this.paramSelfScan.void_qta_max)(control)),
    void_val_max: ((control: AbstractControl) => Validators.max(this.paramSelfScan.void_val_max)(control)),
    num_valid_check: ((control: AbstractControl) => Validators.max(this.paramSelfScan.num_valid_check)(control)),
    min: ((control: AbstractControl) => Validators.max(this.paramSelfScan.min)(control)),
    max: ((control: AbstractControl) => Validators.max(this.paramSelfScan.max)(control)),
    step: ((control: AbstractControl) => Validators.max(this.paramSelfScan.step)(control)),
    min_tx_check: ((control: AbstractControl) =>  Validators.min(0)(control)),
    max_tx_check: ((control: AbstractControl) =>  Validators.min(0)(control)),
    default_check_chance: ((control: AbstractControl) =>  Validators.min(0)(control))
  }

  public invalidSubmit: boolean;

  defaultStartDate: Date;
  defaultEndDate: Date;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    public selfscanService: LoyaltySelfscanconfService,
    private srvDivisionSalesNetwork: DivisionSalesNetworkService,
    private calendarTranslate: CalendarTranslateService,
    private selfscandetailService: LoyaltySelfscanconfdetailService,
    private router: Router,
    private paramService: LoyaltyParamsService
  ) { }

  get details(): FormArray {
    return this.form.get('details') as FormArray;
  }

  ngOnInit() {

    this.selfscanId = this.activatedRoute.snapshot.params['selfscanId'];
    this.editMode = (typeof this.selfscanId !== 'undefined');
    this.selfdetailsForm = [];

    this.divisionSales = [];
    this.divisionSales.push({label: '', value: null});

    let translate: Observable<any>;
    let selfscanconf: Observable<SelfScanConf>;
    let selfdetailsForm: Observable<any>;
    let divisionSale: Observable<Array<DivisionSalesNetwork>>;
    let division: Observable<Array<Division>>;

    let ValidationSelfScan: Observable<any>;
    let ValidationSelfScanDetails: Observable<any>;
    let SelfScanParam: Observable<any>;

    translate = this.translate.get([
      'self_scan.divsal',
      'self_scan.description',
      'self_scan.date_start',
      'self_scan.date_end',
      'self_scan.chk_panel',
      'self_scan.chk_min_num',
      'self_scan.chk_max_num',
      'self_scan.tx_interval',
      'self_scan.void_qta_max',
      'self_scan.void_val_max',
      'self_scan.num_valid_check',
      'self_scan_detail.row_no',
      'self_scan_detail.min',
      'self_scan_detail.max',
      'self_scan_detail.step',
      'self_scan.add_title',
      'self_scan.edit_title',
      'self_scan.min_tx_check',
      'self_scan.max_tx_check',
      'self_scan.default_check_chance'
    ])

    if (!this.editMode) {
      selfscanconf = Observable.of(new SelfScanConf());
      selfdetailsForm = Observable.of(new SelfScanConfDetail());
    }else {
      selfscanconf = this.selfscanService.get(this.selfscanId);
      selfdetailsForm = this.selfscandetailService.list(this.selfscanId);
    }

    divisionSale = this.srvDivisionSalesNetwork.list();
    ValidationSelfScan = this.selfscanService.getFields();
    ValidationSelfScanDetails = this.selfscandetailService.getFields();

    const paramSelfScan = [
      { key: 'param_group', value: 'SelfScanRules' }
    ];

    SelfScanParam = this.paramService.list(0, 15, paramSelfScan);

    Observable.zip(translate, selfscanconf, divisionSale, selfdetailsForm, ValidationSelfScan, ValidationSelfScanDetails, SelfScanParam).subscribe(([resTranslate, resSelfScanConf, resDivisionSale, resSelfdetailsForm, resValidationSelfScan, resValidationSelfScanDetails, resSelfScanParam]) => {

      // prendo i parametri di configurazione per self scan e self scan details per assegnarli ai validatori

      if (resSelfScanParam && resSelfScanParam.data) {
        for (let param of resSelfScanParam.data) {
          let field = param.param_key.replace('SELFSCANRULES.', '').replace('SELFSCANRULESDETAIL.', '');
          this.paramSelfScan[field] = +param.param_code;
        }
      }

      this.validationSelfScan = resValidationSelfScan;
      this.validationSelfScanDetails = resValidationSelfScanDetails;

      if ( !isUndefined(resSelfdetailsForm.data) ) {
        for (const service of resSelfdetailsForm.data) {
          this.selfdetailsForm.push(this.fb.group(this.getSelfDetail(service)));
        }
      }

      this.fields = {
        division_sales_network_id: resTranslate['self_scan.divsal'],
        description: resTranslate['self_scan.description'],
        date_start: resTranslate['self_scan.date_start'],
        date_end: resTranslate['self_scan.date_end'],
        chk_panel: resTranslate['self_scan.chk_panel'],
        chk_min_num: resTranslate['self_scan.chk_min_num'],
        chk_max_num: resTranslate['self_scan.chk_max_num'],
        tx_interval: resTranslate['self_scan.tx_interval'],
        void_qta_max: resTranslate['self_scan.void_qta_max'],
        void_val_max: resTranslate['self_scan.void_val_max'],
        num_valid_check: resTranslate['self_scan.num_valid_check'],
        row_no: resTranslate['self_scan_detail.row_no'],
        min: resTranslate['self_scan_detail.min'],
        max: resTranslate['self_scan_detail.max'],
        step: resTranslate['self_scan_detail.step'],
        add_title: resTranslate['self_scan.add_title'],
        edit_title: resTranslate['self_scan.edit_title'],
        min_tx_check: resTranslate['self_scan.min_tx_check'],
        max_tx_check: resTranslate['self_scan.max_tx_check'],
        default_check_chance: resTranslate['self_scan.default_check_chance']
      };

      if (!this.editMode) {
        this.fields['title'] = this.fields['add_title'];
      }else {
        this.fields['title'] = this.fields['edit_title'];
      }

      // decodifico divisione e salesNetwork
      for (const singleDivision of resDivisionSale) {
        // this.divisionSales.push({label: resDivision.find(el => el.id === singleDivision.division_id).description + ' - ' + resSalesNetwork.find(el => el.id === singleDivision.sales_network_id).description, value: singleDivision.id});
        this.divisionSales.push({label: singleDivision.division_name + ' - ' + singleDivision.sales_network_name, value: singleDivision.id});
      }

      if (resSelfScanConf && resSelfScanConf.date_start) {
        this.defaultStartDate = new Date(resSelfScanConf.date_start);
      }

      if (resSelfScanConf && resSelfScanConf.date_end) {
        this.defaultEndDate = new Date(resSelfScanConf.date_end)
      }

      this.form = this.fb.group({
        division_sales_network_id: [resSelfScanConf.division_sales_network_id || ''],
        description: [resSelfScanConf.description || ''],
        date_start: [(resSelfScanConf && resSelfScanConf.date_start) ? moment(resSelfScanConf.date_start).format(this.calendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase()).toString() : ''],
        date_end: [(resSelfScanConf && resSelfScanConf.date_end) ? moment(resSelfScanConf.date_end).format(this.calendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase()).toString() : ''],
        chk_min_num: [resSelfScanConf.chk_min_num || ''],
        chk_max_num: [resSelfScanConf.chk_max_num || ''],
        tx_interval: [resSelfScanConf.tx_interval || ''],
        void_qta_max: [resSelfScanConf.void_qta_max || ''],
        void_val_max: [resSelfScanConf.void_val_max || ''],
        num_valid_check: [resSelfScanConf.num_valid_check || ''],
        min_tx_check: [resSelfScanConf.min_tx_check || ''],
        max_tx_check: [resSelfScanConf.max_tx_check || ''],
        default_check_chance: [resSelfScanConf.default_check_chance || ''],
        details: this.fb.array(this.selfdetailsForm)
      });
    });

  }

  deleteDetail(i: number, selfdetail: FormGroup) {
    if (!selfdetail.get('id').value) {
      this.details.removeAt(i);
      return;
    }
    this.selfscandetailService.remove(this.selfscanId, selfdetail.get('id').value).subscribe((res) => {
      this.details.removeAt(i);
    });
  }

  getSelfDetail(selfdetail: SelfScanConfDetail) {
    return {
      id: [selfdetail.id || null],
      row_no: [selfdetail.row_no || ''],
      min: [selfdetail.min || ''],
      max: [selfdetail.max || ''],
      step: [selfdetail.step || '']
    };
  }

  save() {

    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }

    const param = new SelfScanConf();
    param.division_sales_network_id = this.form.get('division_sales_network_id').value;
    param.description = this.form.get('description').value;
    param.date_start = moment(this.form.get('date_start').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    param.date_end = moment(this.form.get('date_end').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    // param.date_start = this.form.get('date_start').value;
    // param.date_end = this.form.get('date_end').value;
    param.chk_min_num = +this.form.get('chk_min_num').value;
    param.chk_max_num = +this.form.get('chk_max_num').value;
    param.tx_interval = +this.form.get('tx_interval').value;
    param.void_qta_max = +this.form.get('void_qta_max').value;
    param.void_val_max = +this.form.get('void_val_max').value;
    param.num_valid_check = +this.form.get('num_valid_check').value;
    param.min_tx_check = +this.form.get('min_tx_check').value;
    param.max_tx_check = +this.form.get('max_tx_check').value;
    param.default_check_chance = +this.form.get('default_check_chance').value;

    if (!this.editMode) {
      this.selfscanService.create(param).subscribe(res => {
        this.selfscanId = res.id;
        this.addSelfDetail(this.form.get('details').value);
        this.router.navigate(['/loyalty/selfscanrules']);
      });
    } else {
      param.id = this.selfscanId;
      this.addSelfDetail(this.form.get('details').value);
      this.selfscanService.update(param).subscribe(res => {
        this.router.navigate(['/loyalty/selfscanrules']);
      });
    }
  }

  aggiungi() {
    this.details.push(this.fb.group(
      this.getSelfDetail(new SelfScanConfDetail())
    ));
  }

  addSelfDetail(selfDetails: Array<SelfScanConfDetail>) {
    if (selfDetails.length > 0) {
      const requests = [];
      for (const selfD of selfDetails) {
        if ( !selfD.id ) {
          delete selfD.id;
          requests.push(this.selfscandetailService.create(this.selfscanId, selfD));
        } else {
          const idDetail = selfD.id;
          delete  selfD.id;
          requests.push(this.selfscandetailService.update(this.selfscanId, idDetail, selfD));
        }
      }
      Observable.zip(...requests).subscribe((resCreateDetails) => {
        this.router.navigate(['/loyalty/selfscanrules/']);
      });
    }else {
      this.router.navigate(['/loyalty/selfscanrules/']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-rules/form-self-scan-rules/form-self-scan-rules.component.ts